export default __webpack_public_path__ + "static/media/AddPhoto.a5ba27c3.svg";